module.exports = __webpack_public_path__ + "static/media/IMG_1031.ead66ee7.jpg";